export const MINUTES_BEFORE_EXPIRED_HEARTBEAT_OF_MACHINE = 15;